import { loginWithUserCode, loginWithEmail } from './firebaselogin.js';


const signUpButton = document.getElementById('signUp');
const signInButton = document.getElementById('signIn');
const container = document.getElementById('container');
const loginBtn = document.getElementById('loginBtn');

// Panel geçiş işlemleri
if (signUpButton) {
    signUpButton.addEventListener('click', () => {
        container.classList.add("right-panel-active");
    });
}

if (signInButton) {
    signInButton.addEventListener('click', () => {
        container.classList.remove("right-panel-active");
    });
}
if (loginBtn) {
    loginBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const email = document.getElementById('emailInputBx')?.value;
        const password = document.getElementById('passwordInputBx')?.value;
        let result;

        // Email ve şifre kontrolü
        if (!email || !password) {
            return alert('Email ve şifre alanlarını doldurunuz.');
        }

        // Email/şifre ile giriş
        result = await loginWithEmail(email, password);

        // Loading state
        const originalText = loginBtn.textContent;
        loginBtn.classList.add('loading');
        loginBtn.textContent = '';
        
        
        if (result.success) {
            // Success animation
            loginBtn.classList.remove('loading');
            loginBtn.textContent = '✓ Başarılı';
            loginBtn.style.background = 'linear-gradient(135deg, #10b981, #059669)';
            
            // Kullanıcı bilgilerini localStorage'a kaydet
            localStorage.setItem('userName', result.data.userCode);
            localStorage.setItem('userInfo', JSON.stringify(result.data));
            localStorage.setItem('userDocId', result.data.docId);
            
            // Ana sayfaya yönlendir
            setTimeout(() => {
                window.location.replace("/personal/");
            }, 1500);
        } else {
            // Error state
            loginBtn.classList.remove('loading');
            loginBtn.textContent = originalText;
            loginBtn.style.background = 'linear-gradient(135deg, #ef4444, #dc2626)';
            
            setTimeout(() => {
                loginBtn.style.background = 'linear-gradient(135deg, #22c55e, #10b981)';
            }, 2000);
            
            alert(result.error || 'Giriş yapılamadı');
        }
    });
}
// Oturum kontrolü
function checkAuth() {
    const userName = localStorage.getItem('userName');
    const userInfo = localStorage.getItem('userInfo');

    if (userName && userInfo) {
        window.location.replace("/3bsayisallastirma.html");
    }
}


export let getuserName = '';

export function assignUser(name) {
    getuserName = name.toUpperCase();
}
// Sayfa yüklendiğinde oturum kontrolü yap
//checkAuth();

async function logout() {
    const userName = localStorage.getItem('userName');
    if (userName) {
        try {
            const result = await updateLogoutTime(userName);
            if (result.success) {
                localStorage.clear(); // localStorage'ı temizle
                window.location.replace("/index.html"); // Login sayfasına yönlendir
            } else {
                console.error("Çıkış zamanı güncellenemedi:", result.error);
            }
        } catch (error) {
            console.error("Çıkış yapılırken hata oluştu:", error);
        }
    }
}

// Çıkış butonuna event listener ekleyin (eğer varsa)
const logoutBtn = document.getElementById('logoutBtn');
if (logoutBtn) {
    logoutBtn.addEventListener('click', logout);
}

function getRedirect() {
    const userName = localStorage.getItem('userName');
    if (userName) {
        window.location.replace("/3bsayisallastirma.html");
    }
}


export { logout };